import { AreaI } from "interfaces/Area";
import { ReactNode, useState } from "react";

interface Props {
  elemento: AreaI;
  renderActions?: (elemento: AreaI) => ReactNode;
}

export const AreaRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`ResolucionTable-${elemento.id}`}>
        <td>{elemento.id}</td>
        <td>{elemento.nombre}</td>
        <td>{elemento.descripcion}</td>
        <td>{elemento.nivel.nombre}</td>
        {renderActions && (
          <td style={{ maxWidth: "50px" }}>{renderActions(elemento)}</td>
        )}
      </tr>
    </>
  );
};
